export const ventasRoutesMap = {
  gestion: {
    path: '/ventas/gestion',
    name: 'Gestión Facturas',
  },
  emisionMasiva: {
    path: `/ventas/emisionMasiva`,
    name: 'Emision Masiva',
  },
  emisionPaquetes: {
    path: `/ventas/emisionPaquetes`,
    name: 'Emision Paquetes',
  },
  emision: {
    path: `/ventas/emision`,
    name: 'Emision Unitaria',
  },
}
